import {Link as RouterDomLink} from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import AddIcon from '@mui/icons-material/Add';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useState } from 'react';

interface TestSidebarProps {
    tests: Array<string>,
    suites: Array<string>,
    setShowNewTest: React.Dispatch<React.SetStateAction<boolean>>,
    setShowNewSuite: React.Dispatch<React.SetStateAction<boolean>>
}

const drawerWidth = 240;

export const TestSidebar = (props: TestSidebarProps) => {
    const [suiteAccordion, setSuiteAccordion] = useState(true);
    const [testAccordion, setTestAccordion] = useState(true);

    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' }
            }}
        >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
                <List
                    component={'nav'}
                    subheader={
                        <ListSubheader component="div" id="test-automation-subheader">
                            Test Automation
                        </ListSubheader>
                    }>
                    <ListItemButton onClick={() => setTestAccordion(!testAccordion)}>
                        <ListItemText primary="Tests" />
                        {testAccordion ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={testAccordion} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {props.tests.map(test => (
                                <ListItemButton key={test} sx={{ pl: 4 }} component={RouterDomLink} to={`/test-automation/test-case/${test}`}>
                                <ListItemText primary={test} />
                                     </ListItemButton>
                            ))}
                        </List>
                    </Collapse>
                    <ListItemButton onClick={() => props.setShowNewTest(true)}>
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Add Test'} />
                    </ListItemButton>
                <Divider />
                <ListItemButton onClick={() => setSuiteAccordion(!suiteAccordion)}>
                        <ListItemText primary="Suites" />
                        {suiteAccordion ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={suiteAccordion} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {props.suites.map(suite => (
                                <ListItemButton key={suite} sx={{ pl: 4 }} component={RouterDomLink} to={`/test-automation/suites/${suite}`}>
                                    <ListItemText primary={suite} />
                                </ListItemButton>
                            ))}
                        </List>
                    </Collapse>
                    <ListItemButton onClick={() => props.setShowNewSuite(true)}>
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Add Suite'} />
                    </ListItemButton>
                </List>
            </Box>
        </Drawer>
    )
}